import { render, staticRenderFns } from "./home-page.vue?vue&type=template&id=38daa335&scoped=true&"
import script from "./home-page.vue?vue&type=script&lang=js&"
export * from "./home-page.vue?vue&type=script&lang=js&"
import style0 from "./home-page.vue?vue&type=style&index=0&id=38daa335&scoped=true&lang=scss&"
import style1 from "./home-page.vue?vue&type=style&index=1&id=38daa335&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38daa335",
  null
  
)

export default component.exports